import { useState } from "react";

import { t } from "../../lib/i18n";

import { Button } from "./Button";

interface CopyButtonProps {
  value: string;
  labelKey?: string;
  size?: "sm" | "md";
  variant?: "secondary" | "ghost" | "primary";
}

export function CopyButton({
  value,
  labelKey = "common.copy",
  size = "sm",
  variant = "secondary",
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API blocked; nothing to do silently.
    }
  };

  return (
    <Button variant={variant} size={size} onClick={() => void onClick()}>
      {copied ? t("common.copied") : t(labelKey)}
    </Button>
  );
}
